export function toLocaleString(value, decimals = 1, emptyValue = null, formatZeroes = false) {
    return value || formatZeroes
        ? value.toLocaleString(navigator.language, {
              minimumFractionDigits: decimals,
              maximumFractionDigits: decimals
          })
        : emptyValue;
}

export function round(value, decimals = 1, emptyValue = null) {
    return value ? parseFloat(Number(value).toFixed(decimals)) : emptyValue;
}

export const sum = arr => arr.reduce((a, b = 0) => a + b, 0) || 0;

export const average = arr => arr.reduce((a, b = 0) => a + b, 0) / arr.length || 0;

export const averageOnlyWithValues = arr => arr.reduce((a, b = 0) => a + b, 0) / arr.filter(Boolean).length || 0;

export function calculatePercentage(value, total, decimals = 2, emptyValue = 0) {
    if (!total) return emptyValue;
    if (value < 0) return 0;
    return round((value * 100) / total, decimals) || emptyValue;
}
